import styled, { css } from 'styled-components';

import { Colour } from '@xemplo/colours';
import {
  inputContainerStateStyles,
  inputContainerStyles,
  inputFocus,
  InputSize,
} from '@xemplo/input-utils';

const straightenBorders = css`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

export const TriggerElementWrapper = styled.div`
  ${inputContainerStyles};
  ${inputContainerStateStyles};
  ${straightenBorders};
  --input-width: 56px;

  border-left: none;
  flex-shrink: 0;
  padding: 0 16px;

  &.${InputSize.Default} {
    --input-height: 48px;
  }

  &.${InputSize.Compact} {
    --input-height: 40px;
  }

  &.${InputSize.Spacious} {
    --input-height: 64px;
  }

  & > svg {
    color: ${Colour.Clarity.Content.Soft};
  }

  &:hover {
    background-color: ${Colour.Clarity.Grey.ExtraSoft};
  }

  &.open {
    ${inputFocus};
    ${straightenBorders};
    border-left: 1px solid var(--input-border-color);
  }
`;
